var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_47660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0681 4H3.26787C2.38415 4 1.66797 4.71618 1.66797 5.59991V15.1998C1.66797 16.0835 2.38415 16.7997 3.26787 16.7997H16.0681C16.9518 16.7997 17.668 16.0835 17.668 15.1998V5.59991C17.668 4.71618 16.9513 4 16.0681 4ZM16.0681 15.1998H3.26787V5.59991H16.0681V15.1998Z",
    fill: "#F8FAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66556 13.6983C11.4842 13.6983 12.9639 12.2185 12.9639 10.3999C12.9639 8.58132 11.4842 7.10156 9.66556 7.10156C7.84695 7.10156 6.36719 8.58132 6.36719 10.3999C6.36719 12.2185 7.84695 13.6983 9.66556 13.6983ZM9.66556 8.50905C10.7079 8.50905 11.556 9.35711 11.556 10.3995C11.556 11.4418 10.7079 12.2899 9.66556 12.2899C8.6232 12.2899 7.77514 11.4418 7.77514 10.3995C7.77514 9.35711 8.6232 8.50905 9.66556 8.50905Z",
    fill: "#F8FAFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_47660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12.7997,
    fill: "white",
    transform: "translate(1.66797 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashNewIcon);
export default __webpack_public_path__ + "static/media/cashNewIcon.00eafdbe2009477b718b0aa8cb90dcd2.svg";
export { ForwardRef as ReactComponent };